import { YhBox } from '@/components/YhBox'
import useNavModel from '@/model/navModel'
import { Button, Upload } from 'antd'
import React from 'react'
import { useSupplierModel } from '../supplierModel'
import { DataTable } from './DataTable'
import { globalPrompt } from '@/components/message'
import { useSupplierDetailsMode } from './details/supplierDetailsModel'
import { importPropsConfig } from '@/utils/importFile'
import useGlobalModel from '@/model/globalModel'

export const DataBox = () => {
    const {setLoadingInfo } = useGlobalModel();
    const { selectedRowKeys, exportTemplate, loadData } = useSupplierModel()
    const { addNav, findNav, selectNav, switchNavState } = useNavModel()
    const { resetEditCatch } = useSupplierDetailsMode()
    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            //没有
            globalPrompt('message', { text: '请选择单条数据进行编辑，点击鼠标右键可一键选中哦！', type: 'warning' })
            return
        }
        let purchaseDrEditKey = '2-2'
        let isFindNav = findNav(purchaseDrEditKey)
        if (!isFindNav) {
            addNav(purchaseDrEditKey, { id: selectedRowKeys[0] as string, mode: 'edit' })
            resetEditCatch()
        } else {
            globalPrompt('modal', {
                title: '调入单跳转详情',
                type: 'warning',
                text: '您还有调入单单详情未保存，是否跳转',
                okText: '跳转未保存页',
                onOk: () => selectNav(isFindNav ? isFindNav.id : ''),
                cancelText: '打开新页签',
                onCancel: () => {
                    switchNavState(purchaseDrEditKey, { id: selectedRowKeys[0] as string, mode: 'edit' })
                    resetEditCatch()
                },
            })
        }
    }

    const upLoadCallback = (value: object | undefined) => {
        value && loadData();
        //不管导入成功与否， 将全局loading恢复初始值。
        setLoadingInfo({ loadingVisible: false, txt: "" });
    }


    const action = (
        <>
            <Button className="mr-5" type="link" shape="round" onClick={() => addNav('2-1', { id: '', mode: 'add' })}>
                新增
            </Button>
            <Button className="mr-5" type="link" shape="round" onClick={onEdit}>
                编辑
            </Button>

            <Upload
                showUploadList={false}
                className="mr-10 ml-10"
                {...importPropsConfig(`/sum/supplier/import`, upLoadCallback, () => setLoadingInfo({ loadingVisible: true, txt: '快速导入中' }))}
            >
                <Button className="mr-5" type="link" shape="round">
                    导入
                </Button>
            </Upload>
            <Button className="mr-5" type="link" shape="round" onClick={exportTemplate}>
                下载模版
            </Button>
        </>
    )
    return (
        <YhBox title="供应商列表" action={action}>
            <DataTable />
        </YhBox>
    )
}
